var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#FFD15C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5467 18H31.432V20.8507H34.072V18H36.9573V26.6293H34.072V23.7413H31.432V26.6293H28.5493V18H28.5467ZM40.7493 20.8613H38.2107V18H46.176V20.8613H43.6347V26.6293H40.7493V20.8613ZM47.44 18H50.448L52.2987 21.032L54.1467 18H57.1547V26.6293H54.2827V22.352L52.2987 25.4213H52.248L50.2613 22.3547V26.6293H47.44V18ZM58.5893 18H61.4773V23.7787H65.5307V26.632H58.5893V18Z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.456 76.8587L23 30.5787H71L65.5413 76.8533L46.9733 82L28.456 76.8587ZM39.488 51.5253L38.9707 45.712H60.6907L61.1973 40.0373H32.7707L34.3013 57.2027H53.9733L53.3147 64.5627L46.984 66.2747H46.9787L40.6587 64.568L40.2533 60.0427H34.552L35.3467 68.9547L46.9733 72.1813L58.6187 68.9547L60.0373 53.0507L60.176 51.528H39.488V51.5253Z",
    fill: "#111827"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(15 18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.5ae82e94f2252dab35dd02538847145e.svg";
export { ForwardRef as ReactComponent };